import { render, staticRenderFns } from "./EditPerDocumentStockSettings.vue?vue&type=template&id=26d3f8e9"
import script from "./EditPerDocumentStockSettings.vue?vue&type=script&lang=ts"
export * from "./EditPerDocumentStockSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports